<span (click)="openDialog()" class="view-more">Ver cargos a pagar en destino</span>
